import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

// 获取原型对象上的replace函数  ps:如果是push，把replace 改成push
const originalPush = VueRouter.prototype.push
// 修改原型对象中的replace方法  ps:如果是push，把replace 改成push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/newsList',
    name: 'NewsList',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/NewsList.vue')
  },
  {
    path: '/newsDetail',
    name: 'NewsDetail',
    component: () => import('../views/NewsDetail.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
